import { gql } from 'graphql-request'

export const QueryBlockRichTextBlock = gql`
  fragment FragmentBlockRichText on BlockRichTextModelRecord {
    __typename
    id
    anchor
    text {
      value
      links {
        ...FragmentLinkReferences
      }
      blocks {
        id
        __typename
        file {
          format
          url
          responsiveImage {
            ...responsiveImageFragment
          }
        }
      }
    }
  }
`

export const BlockRichText = {
  __typename: 'BlockRichText',
  fragmentName: 'FragmentBlockRichText',
  fragmentQuery: QueryBlockRichTextBlock,
  fragments: []
}

//REferences
